<template>
  <div class="event-notice">
    <event-detail-title :type="anchorMap.NOTICE_KEY"></event-detail-title>
    <div class="section-content">
      <markdown-beautiful :data="events_notice_html"></markdown-beautiful>
    </div>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import markdownBeautiful from '@/components/markdown-beautiful'
import eventDetailTitle from './event-detail-title'
import { anchorMap } from './utils'

export default {
  name: 'event-detail-notice',
  data () {
    return {
      anchorMap
    }
  },
  components: {
    markdownBeautiful,
    eventDetailTitle
  },
  props: {
    events_notice_html: vueTypes.string.isRequired
  }
}
</script>

<style lang="scss" scoped>

</style>
